import qs from 'qs'
import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { IGetRequestObject, ITrainingComplianceByPerson } from '../../interfaces'

type QueryObject = {
  searchTerm?: string,
  trainingGroupId?: number,
  asOfDate?: string
}

const getTrainingComplianceByPersonRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })
  return {
    method: 'get',
    url: `${config.baseUrl}/training/compliance/by-person${queryString}`,
  }
}

const useTrainingComplianceByPersonQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingComplianceByPerson[] | undefined
>({
  getRequest: getTrainingComplianceByPersonRequest,
  getQueryKey: (params, queryObject) => [
    'training-compliance-by-person',
    queryObject?.searchTerm,
    queryObject?.trainingGroupId,
    queryObject?.asOfDate
  ],
})

const useTrainingComplianceByPersonQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingComplianceByPerson[] | undefined, Error>,
) => {
  const trainingComplianceByPersonQuery = useTrainingComplianceByPersonQueryBase(
    undefined,
    queryObject,
    options,
  )
  return { ...trainingComplianceByPersonQuery }
}

export default useTrainingComplianceByPersonQuery